import React from 'react';
import { SectionWrapper } from '../ui/SectionWrapper';
import { AlertTriangle, Lock, FileQuestion } from 'lucide-react';
export function WhySection() {
  return <SectionWrapper background="white" data-id="element-284">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start" data-id="element-285">
        <div className="lg:col-span-5" data-id="element-286">
          <div className="inline-block px-3 py-1 bg-red-50 text-red-700 text-xs font-bold rounded-full mb-6" data-id="element-287">
            The Reality Check
          </div>
          <h2 className="text-3xl font-bold text-slate-900 mb-6 tracking-tight" data-id="element-288">
            73% of new D2D reps leave within their first year.
          </h2>
          <div className="space-y-4 text-slate-600 leading-relaxed" data-id="element-289">
            <p data-id="element-290">
              Door-to-door sales offers incredible financial upside, but the
              failure rate is staggering. Why? Because talent is often wasted on
              bad systems.
            </p>
            <p data-id="element-291">
              Most industry information is biased, incomplete, or designed to
              sell you a course. This forces operators and reps to learn the
              hard way—losing time, money, and reputation.
            </p>
            <div className="pt-4" data-id="element-292">
              <p className="text-slate-900 font-medium border-l-4 border-teal-500 pl-4 italic" data-id="element-293">
                "D2D Guides exists to explain the tradeoffs before you pay the
                price."
              </p>
            </div>
          </div>
        </div>

        <div className="lg:col-span-7 grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-294">
          <div className="bg-slate-50 p-6 rounded-lg border border-slate-100" data-id="element-295">
            <div className="w-10 h-10 bg-white rounded-lg border border-slate-200 flex items-center justify-center mb-4 shadow-sm" data-id="element-296">
              <AlertTriangle className="w-5 h-5 text-amber-600" data-id="element-297" />
            </div>
            <h3 className="font-bold text-slate-900 mb-2 text-sm" data-id="element-298">
              Biased Information
            </h3>
            <p className="text-slate-500 text-sm leading-relaxed" data-id="element-299">
              Recruiting hype often masks operational reality and market
              saturation.
            </p>
          </div>

          <div className="bg-slate-50 p-6 rounded-lg border border-slate-100" data-id="element-300">
            <div className="w-10 h-10 bg-white rounded-lg border border-slate-200 flex items-center justify-center mb-4 shadow-sm" data-id="element-301">
              <Lock className="w-5 h-5 text-slate-600" data-id="element-302" />
            </div>
            <h3 className="font-bold text-slate-900 mb-2 text-sm" data-id="element-303">
              Hidden Tradeoffs
            </h3>
            <p className="text-slate-500 text-sm leading-relaxed" data-id="element-304">
              High commissions often come with high risk, clawbacks, or zero
              support.
            </p>
          </div>

          <div className="bg-slate-50 p-6 rounded-lg border border-slate-100" data-id="element-305">
            <div className="w-10 h-10 bg-white rounded-lg border border-slate-200 flex items-center justify-center mb-4 shadow-sm" data-id="element-306">
              <FileQuestion className="w-5 h-5 text-teal-600" data-id="element-307" />
            </div>
            <h3 className="font-bold text-slate-900 mb-2 text-sm" data-id="element-308">
              No Standards
            </h3>
            <p className="text-slate-500 text-sm leading-relaxed" data-id="element-309">
              Without a framework, it's impossible to compare opportunities
              apples-to-apples.
            </p>
          </div>
        </div>
      </div>
    </SectionWrapper>;
}